import parse from 'html-react-parser';
import { API_URL } from "../../global/components/Constants";
import { parseMarginPadding, parseResult } from '../controlUtils';
import { hexToRgba } from '../colorUtils';

export function displayPhotoUtil(obj, entryPoint){

    const content = JSON.parse(obj.Content);
    const title = parse(content.Title);
    const theme = content.Theme;
    const size = content.Size;
    const desc = content.Description;
    const photo = obj.Photo;
    const marginPadding = content.MarginPadding;
    
    const src = (photo.length > 200)? photo: `${API_URL}/uploads/topic/component/${photo}`; 
    const mp = parseMarginPadding(marginPadding);

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    let imgSz = 0; let titleSz = 0; let textSz = 0; let zoom = 0;
    if(size == "small"){ imgSz=200 ; titleSz=14; textSz=11 }
    else if(size == "medium"){ imgSz=400; titleSz=18; textSz=14 }
    else if(size == "large"){ imgSz=600; titleSz=22; textSz=16 }
    else if(size == "xlarge"){ imgSz=800; titleSz=22; textSz=16 }

    if(entryPoint == "presentation" && obj.Presentation != ""){
        const ptn = JSON.parse(obj.Presentation);
        if(ptn.TitleSize != "") { titleSz = parseInt(ptn.TitleSize) }
        if(ptn.TextSize != "") { textSz = parseInt(ptn.TextSize) }
        if(ptn.Zoom != "") { zoom = parseInt(ptn.Zoom) }
    }

    if(entryPoint == "editor"){
        zoom = 60;
    }

    const styles = {
        container: {
            maxWidth: imgSz,
            flex: 1,
            zoom: `${zoom}%`,
            marginTop: mp.marginTop,
            marginRight: mp.marginRight,
            marginBottom: mp.marginBottom,
            marginLeft: mp.marginLeft,
        },
        body:{
            position: 'relative',
        },
        photo:{
            width: '100%',
            borderRadius: 5
        },
        caption:{
            background: hexToRgba(bgColor, 0.9),
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            borderBottomLeftRadius:5,
            borderBottomRightRadius:5,
        },
        title: {
            color: txtColor,
            marginBottom: 5,
            fontSize: titleSz,
            fontWeight: 600
        },
        desc:{
            color: txtColor,
            fontSize: textSz,
        }
    }

    const elem = (
        <div style={styles.container}>

            <div style={styles.body}>
                {(photo != "") &&
                    <img  src = {src} style={styles.photo} />
                }
                {(title != "" || desc != "") &&
                    <div style = {styles.caption}>
                        {(title != "") && <h4 style = {styles.title}>{parse(checkLength('title', title))}</h4>}
                        {(desc != "") && <div style = {styles.desc}>{parse(checkLength('text', desc))}</div>}
                    </div>
                }
            </div>
        </div>
    )

    return parseResult(elem, obj, entryPoint);
}

function checkLength(type, val){

    let lnt = 0; 
    if(type == "title") {
        lnt = 30
    }
    else if(type == "text") {
        lnt = 100
    }

    return val.substring(0, lnt);
}